class HeaderTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const announcement = this.closest('.hd-Announcement')

    if (announcement?.classList.contains('hd-Announcement-top')) {
      document.body.classList.add('lyt-Theme-hasAnnouncementTop')
    } else {
      document.body.classList.add('lyt-Theme-hasAnnouncementBottom')
    }

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const tickerWidth = this.els.items.element.offsetWidth / 50
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('header-ticker')) {
  customElements.define('header-ticker', HeaderTicker)
}
